import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProjectRepAssigned from '../../ProjectRepAssigned';
import ProjectFeedbacks from '../../ProjectFeedbacks';
import SharesTable from '../../SharesTable';
import { formatCurrency } from '../../../numberUtils';
import { putRequest } from '../../../requestUtils';
import NextSteps from '../NextSteps';
var ProjectSidebar = /*#__PURE__*/function (_Component) {
  function ProjectSidebar(props) {
    var _this;
    _classCallCheck(this, ProjectSidebar);
    _this = _callSuper(this, ProjectSidebar, [props]);
    _this.handleAcceptRehireRequest = _this.handleAcceptRehireRequest.bind(_this);
    _this.handleCloseProject = _this.handleCloseProject.bind(_this);
    _this.handleUpdateNextSteps = _this.handleUpdateNextSteps.bind(_this);
    return _this;
  }
  _inherits(ProjectSidebar, _Component);
  return _createClass(ProjectSidebar, [{
    key: "handleCloseProject",
    value: function () {
      var _handleCloseProject = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var _this$props, project, csrfToken;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, project = _this$props.project, csrfToken = _this$props.csrfToken;
              e.preventDefault();
              _context.next = 4;
              return putRequest("/projects/".concat(project.resource_id, "/close"), {
                project: {
                  resource_id: project.resource_id
                }
              }, csrfToken);
            case 4:
              window.location.reload();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleCloseProject(_x) {
        return _handleCloseProject.apply(this, arguments);
      }
      return handleCloseProject;
    }()
  }, {
    key: "handleAcceptRehireRequest",
    value: function () {
      var _handleAcceptRehireRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$props2, project, csrfToken;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = this.props, project = _this$props2.project, csrfToken = _this$props2.csrfToken;
              _context2.next = 3;
              return putRequest("/projects/".concat(project.resource_id, "/accept_rehire_request"), {
                project: {
                  resource_id: project.resource_id
                }
              }, csrfToken);
            case 3:
              window.location.reload();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleAcceptRehireRequest() {
        return _handleAcceptRehireRequest.apply(this, arguments);
      }
      return handleAcceptRehireRequest;
    }()
  }, {
    key: "handleUpdateNextSteps",
    value: function () {
      var _handleUpdateNextSteps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(action, link) {
        var _this$props3, csrfToken, projectResourceId, _yield$putRequest, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this$props3 = this.props, csrfToken = _this$props3.csrfToken, projectResourceId = _this$props3.projectResourceId;
              _context3.next = 3;
              return putRequest("/projects/".concat(projectResourceId, "/update_next_steps"), {
                action_clicked: action
              }, csrfToken);
            case 3:
              _yield$putRequest = _context3.sent;
              data = _yield$putRequest.data;
              this.setState({
                nextStepsData: data
              });
              if (action === 'scoping_call') {
                window.open(link, '_blank');
              } else {
                window.location.href = link;
              }
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleUpdateNextSteps(_x2, _x3) {
        return _handleUpdateNextSteps.apply(this, arguments);
      }
      return handleUpdateNextSteps;
    }()
  }, {
    key: "renderRate",
    value: function renderRate() {
      var _this$props4 = this.props,
        project = _this$props4.project,
        acceptedProposal = _this$props4.acceptedProposal;
      if (project.employment_type === 'full_time') {
        if (!acceptedProposal.base_annual_pay) {
          return null;
        }
        return "".concat(formatCurrency(acceptedProposal.base_annual_pay, 0), "/yr");
      }
      if (!acceptedProposal.public_hourly_rate) {
        return null;
      }
      return "".concat(formatCurrency(acceptedProposal.public_hourly_rate, 0), "/h");
    }
  }, {
    key: "renderWorkCompletedReview",
    value: function renderWorkCompletedReview() {
      var _this2 = this;
      var _this$props5 = this.props,
        project = _this$props5.project,
        review = _this$props5.review,
        acceptedProposal = _this$props5.acceptedProposal;
      var consultantName = acceptedProposal && acceptedProposal.consultant_name.split(' ')[0] || 'Candidate';
      var companyLink = project.company_link;
      return /*#__PURE__*/React.createElement("div", {
        className: "project-review box-shadow-1"
      }, review.persisted && !review.editable ? /*#__PURE__*/React.createElement("h2", {
        className: "demibold mb-12"
      }, "Project completed by:") : [/*#__PURE__*/React.createElement("h2", {
        className: "demibold mb-12"
      }, "How was your experience?"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mb-3"
      }, "Tell us how working with ".concat(consultantName, " was for this specific project."))], /*#__PURE__*/React.createElement("div", {
        className: "fs-hide body-text-1 demibold mb-6 consultant-name"
      }, /*#__PURE__*/React.createElement("a", {
        href: acceptedProposal.consultant_url,
        target: "_blank",
        rel: "noreferrer"
      }, consultantName)), acceptedProposal.public_hourly_rate > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 hourly-rate mb-3"
      }, this.renderRate()) : '', review.persisted && !review.editable ? [/*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return _this2.handleUpdateNextSteps('extend_contract_or_hire_again', "".concat(acceptedProposal.consultant_url, "/hire_again?company_resource_id=").concat(companyLink.split('/').at(-1)));
        },
        className: "btn standard-button btn-primary rehire-btn mb-3 full-width",
        role: "button",
        tabIndex: 0
      }, "Hire Again"), /*#__PURE__*/React.createElement("a", {
        href: acceptedProposal.review_proposal_url,
        className: "btn btn-secondary standard-button body-text-2 review-proposal-btn",
        target: "_blank",
        rel: "noreferrer"
      }, "View Proposal")] : '', review.persisted ? [/*#__PURE__*/React.createElement("a", {
        href: review.url,
        className: 'btn btn-primary standard-button body-text-2 ' + 'rate-and-review-btn view-review-btn mt-2'
      }, "View Review"), /*#__PURE__*/React.createElement("div", {
        className: "muted-gray-text body-text-2 mt-2"
      }, "Note: You can edit your review before", ' ', review.editable_deadline, ". After that we will record and publish it.")] : [/*#__PURE__*/React.createElement("a", {
        href: "/projects/".concat(project.resource_id, "/reviews/new"),
        className: 'btn btn-primary standard-button body-text-2 ' + 'rate-and-review-btn new-review-btn'
      }, "Rate & Review", ' ', consultantName), /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return _this2.handleUpdateNextSteps('extend_contract_or_hire_again', acceptedProposal.consultant_url);
        },
        className: "btn standard-button btn-secondary rehire-btn mt-3 full-width",
        role: "button",
        tabIndex: 0
      }, "Hire Again")]);
    }
  }, {
    key: "renderProposalCta",
    value: function renderProposalCta() {
      var _this3 = this;
      var _this$props6 = this.props,
        project = _this$props6.project,
        acceptedProposal = _this$props6.acceptedProposal,
        authUserCanSeeProposal = _this$props6.authUserCanSeeProposal,
        showHourlyRate = _this$props6.showHourlyRate,
        proposalCtaExplanationForEmployer = _this$props6.proposalCtaExplanationForEmployer,
        showHireAgain = _this$props6.showHireAgain;
      var companyLink = project.company_link;
      var matchingOrRequestedMatching = project.status === 'clora_matching' || project.status === 'employer_requested_matching';
      if (!authUserCanSeeProposal || !(!matchingOrRequestedMatching || proposalCtaExplanationForEmployer || acceptedProposal)) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "count-header employer-proposal no-top-border box-shadow-1 mt-2"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "demibold mb-2"
      }, matchingOrRequestedMatching ? '' : /*#__PURE__*/React.createElement("span", null, project.proposal_cta_for_employer, /*#__PURE__*/React.createElement("i", {
        className: "ms-2 fas fa-star"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 regular"
      }, proposalCtaExplanationForEmployer), acceptedProposal ? /*#__PURE__*/React.createElement("div", {
        className: "accepted-proposal mt-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "fs-hide body-text-1 demibold ".concat(showHourlyRate ? 'mb-3' : 'mb-3', " consultant-name")
      }, /*#__PURE__*/React.createElement("a", {
        href: acceptedProposal.consultant_url,
        target: "_blank",
        rel: "noreferrer",
        className: " ps-0 mb-5"
      }, acceptedProposal.consultant_name), showHourlyRate && /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 hourly-rate mb-4"
      }, this.renderRate()), showHireAgain && /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return _this3.handleUpdateNextSteps('extend_contract_or_hire_again', "".concat(acceptedProposal.consultant_url, "/hire_again?company_resource_id=").concat(companyLink.split('/').at(-1)));
        },
        className: "btn standard-button btn-primary rehire-btn w-100",
        role: "button",
        tabIndex: 0
      }, "Hire Again"), /*#__PURE__*/React.createElement("a", {
        href: acceptedProposal.review_proposal_url,
        className: "btn standard-button ".concat(showHireAgain ? 'btn-secondary' : 'btn-primary', " view-profile-btn mt-2 mb-4 w-100"),
        target: "_blank",
        rel: "noreferrer"
      }, "View Proposal"))) : '');
    }
  }, {
    key: "renderProjectFeedback",
    value: function renderProjectFeedback() {
      var _this$props7 = this.props,
        project = _this$props7.project,
        userType = _this$props7.userType,
        invitedColleagues = _this$props7.invitedColleagues,
        invitedFeedback = _this$props7.invitedFeedback,
        projectPermissionLevel = _this$props7.projectPermissionLevel,
        colleagues = _this$props7.colleagues,
        csrfToken = _this$props7.csrfToken,
        currentUserEmail = _this$props7.currentUserEmail;
      var draftOrRequestedMatching = project.status === 'employer_draft' || project.status === 'employer_requested_matching';
      if ((userType === 'rep' || !draftOrRequestedMatching) && project.feedbacks.length) {
        return /*#__PURE__*/React.createElement(ProjectFeedbacks, {
          canComment: false,
          canInvite: project.can_invite,
          feedbacks: project.feedbacks,
          resource: "project",
          invitedColleagues: invitedColleagues,
          ownerEmail: project.owner_email,
          ownerName: project.owner
        });
      }
      if (projectPermissionLevel !== 'invoice_approver' && draftOrRequestedMatching) {
        return /*#__PURE__*/React.createElement(ProjectFeedbacks, {
          canComment: true,
          canInvite: project.can_invite,
          feedback: invitedFeedback,
          feedbacks: project.feedbacks,
          invitedColleagues: invitedColleagues,
          colleagues: colleagues,
          csrfToken: csrfToken,
          resource: "project",
          resourceId: project.resource_id,
          inviteUrl: "/projects/".concat(project.resource_id, "/project_feedbacks/invite"),
          emailShareUrl: "/projects/".concat(project.resource_id, "/project_feedbacks/reminder"),
          email: currentUserEmail,
          confirmEmailUrl: "/confirmation/resend",
          ownerEmail: project.owner_email,
          ownerName: project.owner
        });
      }
      return !(userType === 'rep' || projectPermissionLevel) ? this.renderStartProject() : '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props8 = this.props,
        project = _this$props8.project,
        userType = _this$props8.userType,
        projectPermissionLevel = _this$props8.projectPermissionLevel,
        csrfToken = _this$props8.csrfToken,
        reps = _this$props8.reps,
        shareOptions = _this$props8.shareOptions,
        shareRecipientOptions = _this$props8.shareRecipientOptions,
        salesBookingLink = _this$props8.salesBookingLink,
        invitationsCount = _this$props8.invitationsCount,
        clickTab = _this$props8.clickTab,
        initialTeamMembers = _this$props8.initialTeamMembers,
        editableRoles = _this$props8.editableRoles,
        basePermissionsUrl = _this$props8.basePermissionsUrl,
        invitableRoles = _this$props8.invitableRoles,
        nextStepsData = _this$props8.nextStepsData,
        googleOmniauthUrl = _this$props8.googleOmniauthUrl,
        msOmniauthUrl = _this$props8.msOmniauthUrl,
        signInUrl = _this$props8.signInUrl,
        inviterId = _this$props8.inviterId,
        projectResourceId = _this$props8.projectResourceId;
      return /*#__PURE__*/React.createElement("div", {
        className: "g-flex-4 right-side project-actions-column"
      }, !['closed', 'work_completed'].includes(nextStepsData.project_status) && /*#__PURE__*/React.createElement(NextSteps, {
        nextStepsData: nextStepsData,
        clickTab: clickTab,
        csrfToken: csrfToken,
        initialTeamMembers: initialTeamMembers,
        editableRoles: editableRoles,
        basePermissionsUrl: basePermissionsUrl,
        invitableRoles: invitableRoles,
        salesBookingLink: salesBookingLink,
        googleOmniauthUrl: googleOmniauthUrl,
        msOmniauthUrl: msOmniauthUrl,
        signInUrl: signInUrl,
        projectResourceId: projectResourceId,
        inviterId: inviterId
      }), userType && userType === 'rep' ? [/*#__PURE__*/React.createElement("div", {
        key: "rep-assigned",
        className: "pb-4 project-proposals-flex-container"
      }, /*#__PURE__*/React.createElement(ProjectRepAssigned, {
        reps: reps,
        assignedRep: project.assigned_rep,
        csrfToken: csrfToken,
        project: project
      })), /*#__PURE__*/React.createElement("div", {
        key: "shares-table",
        className: "bg-white p-0 project-proposals-flex-container"
      }, /*#__PURE__*/React.createElement(SharesTable, {
        triggerType: "button",
        csrfToken: csrfToken,
        project: project,
        shareOptions: shareOptions,
        recipientOptions: shareRecipientOptions
      }))] : '', project.status === 'employer_requested_matching' && userType === 'employer' ? /*#__PURE__*/React.createElement("div", {
        className: "schedule-call box-shadow-1 white-container mb-2"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "bold"
      }, "Schedule a call", /*#__PURE__*/React.createElement("i", {
        className: "fas fa-calendar"
      })), /*#__PURE__*/React.createElement("p", {
        className: "body-text-2 mt-2 mb-3 subtext"
      }, "Meet with a Clora rep to complete your project."), /*#__PURE__*/React.createElement("p", {
        className: "booking-button center"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return _this4.handleUpdateNextSteps('scoping_call', salesBookingLink);
        },
        className: "btn btn-primary",
        role: "button",
        tabIndex: 0
      }, "Schedule a Call"))) : '', project.status === 'work_completed' && projectPermissionLevel === 'owner' ? this.renderWorkCompletedReview() : project.status !== 'employer_draft' && this.renderProposalCta(), userType === 'rep' && invitationsCount ? /*#__PURE__*/React.createElement("div", {
        className: 'project-sent-invitations-container' + ' white-container box-shadow-1 mb-3'
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-1 demibold"
      }, /*#__PURE__*/React.createElement("a", {
        href: "/projects/".concat(project.resource_id, "/project_invitations"),
        id: "invitations-count",
        className: "btn btn-secondary-no-border"
      }, /*#__PURE__*/React.createElement("span", {
        className: "invitations"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-user-plus me-2"
      }), "Invitations"), /*#__PURE__*/React.createElement("span", {
        className: "invitations-count"
      }, invitationsCount, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-angle-right ms-3"
      }))))) : '', project.status === 'closed' ? /*#__PURE__*/React.createElement("div", {
        className: "white-container project-info-box box-shadow-1 mb-3"
      }, /*#__PURE__*/React.createElement("h2", null, "Project Closed"), project.is_request && project.rehire_consultant ? /*#__PURE__*/React.createElement("div", {
        className: "mt-2 body-text-2"
      }, /*#__PURE__*/React.createElement("a", {
        href: "users/".concat(project.rehire_consultant.resource_id)
      }, project.rehire_consultant.name), ", who you requested to work with, is not available. Clora will help you to find the right candidate for your need.") : '') : '', userType === 'rep' && project.rehire_consultant && project.status === 'employer_requested_matching' && /*#__PURE__*/React.createElement("div", {
        className: "white-container rehire-request-rep-actions project-info-box box-shadow-1  mb-3 "
      }, /*#__PURE__*/React.createElement("h2", {
        className: "demibold mb-12"
      }, "Rehire request pending"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 regular"
      }, project.rehire_request_creator.name || project.owner_display, ' ', "requested to rehire", ' ', project.rehire_consultant.name, ' ', "for this project. Check availability with the candidate to move on."), /*#__PURE__*/React.createElement("div", {
        className: "accepted-proposal mt-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "fs-hide body-text-1 medium-weight mb-3 consultant-name"
      }, /*#__PURE__*/React.createElement("a", {
        href: "/users/".concat(project.rehire_consultant.resource_id)
      }, project.rehire_consultant.name)), /*#__PURE__*/React.createElement("a", {
        role: "link",
        tabIndex: 0,
        onClick: this.handleAcceptRehireRequest,
        className: "btn standard-button btn-primary mb-2 full-width"
      }, "Accept Request"), /*#__PURE__*/React.createElement("a", {
        role: "link",
        tabIndex: 0,
        onClick: this.handleCloseProject,
        className: "btn standard-button btn-secondary mb-3 full-width"
      }, "Close Request"))), userType && (projectPermissionLevel || userType === 'rep' || project.feedbacks.length) ? this.renderProjectFeedback() : '');
    }
  }]);
}(Component);
ProjectSidebar.propTypes = {
  project: PropTypes.shape({}).isRequired,
  csrfToken: PropTypes.string.isRequired,
  userType: PropTypes.string,
  projectPermissionLevel: PropTypes.string,
  reps: PropTypes.arrayOf(PropTypes.shape({})),
  shareOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  shareRecipientOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  salesBookingLink: PropTypes.string,
  invitationsCount: PropTypes.number,
  invitedColleagues: PropTypes.arrayOf(PropTypes.shape({})),
  invitedFeedback: PropTypes.shape({}),
  colleagues: PropTypes.arrayOf(PropTypes.shape({})),
  currentUserEmail: PropTypes.string,
  authUserCanSeeProposal: PropTypes.bool,
  review: PropTypes.shape({}),
  proposalCtaExplanationForEmployer: PropTypes.string,
  acceptedProposal: PropTypes.shape({}),
  showHourlyRate: PropTypes.bool,
  showHireAgain: PropTypes.bool,
  nextStepsData: PropTypes.shape({}),
  clickTab: PropTypes.func,
  initialTeamMembers: PropTypes.shape({}),
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  editableRoles: PropTypes.arrayOf(PropTypes.string),
  basePermissionsUrl: PropTypes.string.isRequired,
  projectResourceId: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string,
  inviterId: PropTypes.string
};
ProjectSidebar.defaultProps = {
  userType: null,
  projectPermissionLevel: null,
  reps: [],
  salesBookingLink: null,
  invitationsCount: 0,
  invitedColleagues: [],
  invitedFeedback: null,
  colleagues: [],
  currentUserEmail: '',
  authUserCanSeeProposal: false,
  review: null,
  proposalCtaExplanationForEmployer: null,
  acceptedProposal: null,
  showHourlyRate: false,
  showHireAgain: false,
  nextStepsData: {},
  clickTab: function clickTab() {},
  initialTeamMembers: {},
  invitableRoles: [],
  editableRoles: [],
  googleOmniauthUrl: null,
  msOmniauthUrl: null,
  inviterId: null
};
export default ProjectSidebar;